<template>
  <div class="pdt-20px" v-if="factureDetail">
    <div class="card">
      <header class="header-card">
        <p>
          {{ $t('editionFacture.generalTitle.generalInformations')}}
        </p>
      </header>
      <div class="card-content">
        <div class="columns is-marginless is-paddingless is-multiline editionFacture-entete">
          <div class="column is-6 columns is-marginless is-multiline">
            <span class="column is-12 editionFacture-titre">
              {{$t('editionFacture.informations.reference')}} : {{factureDetail.code}}
            </span>
            <user-selector
              v-model="factureDetail.commercialId"
              :critere="(u) => [constantes.COMMERCIAL, constantes.DIRECTEUR_COMMERCIAL]
                .includes(u.profil)"
              :placeholder="$t('editionFacture.informations.aucunCommercial')"
              :label="$t('editionFacture.informations.trade')"
              :disabled="isCommercial"
              class="column is-9-fullhd is-11-tablet"
              :obligatoire="assistantEtCommercialObligatoireSurCommandeFacture"
            />
            <div class="column is-9-fullhd is-11-tablet columns is-multiline
              is-marginless is-paddingless">
              <div class="column is-8">
                <user-selector
                  v-model="factureDetail.assistantId"
                  :critere="(u) => [constantes.ASSISTANT_COMMERCIAL]
                    .includes(u.profil)"
                  :label="$t('ajoutDevis.informations.assistant')"
                  :placeholder="$t('editionFacture.informations.aucunAssistant')"
                  :obligatoire="assistantEtCommercialObligatoireSurCommandeFacture"
                />
              </div>
              <div class="column is-4">
                <b-field :label="$t('editionFacture.informations.commission')">
                  <input-currency v-model="factureDetail.commissionCommercial" isNumber="true">
                  </input-currency>
                  <span class="icon is-right pdt-15px">
                    <i>%</i>
                  </span>
                </b-field>
              </div>
            </div>
            <div class="column is-9-fullhd is-11-tablet" v-if="agencesSelectionnees.length > 1">
              <selection-agence v-model="factureDetail.agenceId" obligatoire>
              </selection-agence>
            </div>
            <b-field
                :label="$t('editionFacture.informations.regleFacturation')"
                class="column is-4" v-if="modulePresseActive"
                :message="!isSyncRegleWithLignes ?
                          $t('editionCommande.informations.regleFacturation.erreur') : ''"
                :type="!isSyncRegleWithLignes ? 'is-warning' : ''">
              <b-select v-model="factureDetail.regleFacturationId" expanded>
                <option :value="null"></option>
                <option :key="regle.id"
                        :value="regle.id"
                        v-for="regle in getReglesFacturation">
                  {{ regle.libelle }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6 columns is-marginless is-multiline">
            <div class="column is-12 has-text-right">
                <span class="has-text-right editionFacture-titre"
                      v-if="factureDetail.sousType">
                  {{ $t('editionFacture.sousType.'+ factureDetail.sousType.toLowerCase())}}
                </span>
            </div>
            <div v-if="moduleCampagneActive"
              class="column is-offset-4-fullhd
              is-8-fullhd is-offset-1-tablet is-11-tablet has-text-right">
              <selection-campagne
                :label="$t('editionCommande.informations.campagne')"
                :dcf="factureDetail"></selection-campagne>
            </div>
            <b-field :label="$t('editionFacture.informations.theme')"
                     class="column is-offset-4-fullhd
                is-8-fullhd is-offset-1-tablet is-11-tablet has-text-right">
              <b-input v-model="factureDetail.theme">
              </b-input>
            </b-field>
            <b-field :label="$t('editionFacture.informations.billDate')"
                     class="column is-offset-4-fullhd
                is-8-fullhd is-offset-1-tablet is-11-tablet has-text-right">
                <div class="is-offset-7 column is-5">
                  <div class="columns">
                    <b-tooltip class="width-100percent"
                      :label="errorsExercice"
                      multiline
                      type="is-warning"
                      position="is-left"
                      v-if="!exerciceOk">
                      <b-icon icon="alert" custom-size="mdi-24px" type="is-warning"
                        class="column is-2"
                        v-if="!exerciceOk"></b-icon>
                    </b-tooltip>
                    <b-datepicker show-week-numbers
                                  @input="billDateChanged"
                                  v-model="factureDetail.dateDevisCommande"
                                  icon="calendar-today"
                                  class="column"
                                  :class="exerciceOk?'is-12':'is-10'"
                                  position="is-bottom-left"
                                  nearby-selectable-month-days
                                  :editable="true">
                    </b-datepicker>
                  </div>
                </div>
            </b-field>
            <b-field :label="$t('editionFacture.informations.datePremierAffichage')"
                     class="column is-offset-4-fullhd
                is-8-fullhd is-offset-1-tablet is-11-tablet has-text-right">
              <b-datepicker show-week-number
                v-model="factureDetail.datePremierAffichage"
                class="column is-offset-7 is-paddingless"
                icon="calendar-today"
                position="is-bottom-left"
                nearby-selectable-month-days
                :disabled="isDateCampagneDisabled">
              </b-datepicker>
            </b-field>
            <b-field :label="$t('editionFacture.informations.categorieVente')"
                     class="column is-offset-4-fullhd
                is-8-fullhd is-offset-1-tablet is-11-tablet has-text-right">
              <b-select v-model="factureDetail.categorieVente">
                <option :key="categorieVente.code"
                        :value="categorieVente.code"
                        v-for="categorieVente in categorieProduit">
                  {{ $t(categorieVente.libelle) }}
                </option>
              </b-select>
            </b-field>
            <b-field :label="$t('editionFacture.informations.tags')"
                   v-if="factureDetail.sens === constantes.SENS_VENTE"
                   class="column is-offset-4-fullhd tag-has-text-right
                     is-8-fullhd is-offset-1-tablet is-11-tablet has-text-right">
              <query-tags-tag-input
                :tooltipLabel="$t('editionFacture.informations.tagInfo')"
                position="is-top"
                v-model="factureDetail.tags"
                field="tag"
                :moduleTag="constantes.DOCUMENT_VENTE">
              </query-tags-tag-input>
            </b-field>
          </div>
        </div>
        <div
          class="columns is-marginless is-paddingless is-multiline editionFacture-informations">
          <div class="column is-6 columns is-marginless is-multiline">
            <div class="column is-9-fullhd is-11-tablet">
              <div class="list-intervenants-item"
                   :key="index"
                   v-for="(intervenant, index) in listeIntervenants">
                <app-edition-intervenant
                  :class="{'pdb-20px': index < listeIntervenants.length - 1}"
                  :alignADroite="false"
                  :afficherRole="true"
                  :afficherTitre="true"
                  :afficherBox="true"
                  :placeIntervenant="index"
                  :sens="constantes.SENS_VENTE"
                  :facture="factureDetail"
                  :intervenant=intervenant
                  :intervenantsFacture=factureDetail.intervenants
                  @destinataireComptable="destinataireComptable"
                  @payeur="payeur"
                  @updateModeCalculHonoraire="updateModeCalculHonoraire"
                  @addCommentaireFacturationOfIntervenant="addCommentaire"
                  @suppression="supprimerIntervenant(intervenant)"
                  @changeDestinataire ="changeDestinataire(intervenant)">
                </app-edition-intervenant>
              </div>
            </div>
            <div
              class="factureIntervenant column is-9-fullhd is-11-tablet"
              key="ajoutIntervenant">
              <div class="section box editionFacture-ajoutIntervenant"
                   @click="ajouterIntervenant"
                   :class="{
                     'editionFacture-ajoutIntervenant-aucunInter': listeIntervenants.length === 0
                   }">
                <b-icon
                  icon="plus-circle">
                </b-icon>
                <span>{{$t('editionFacture.actions.addCustomer')}}</span>
              </div>
            </div>
            <b-field
              :label="$t('editionFacture.clients.annonceurApplicationTva')"
              class="column is-9-fullhd  is-11-tablet">
              <b-select
                @input="updateApplicationTvaAnnonceur"
                :value="getApplicationTvaAnnonceur"
                expanded>
                <option
                  v-for="item in constantes.LISTE_APPLICATION_TVA"
                  :value="item.code"
                  :key="item.code">
                  {{ $t(item.libelle) }}
                </option>
              </b-select>
            </b-field>
            <b-field :label="$t('editionFacture.informations.accountingAccount')"
                     class="column is-9-fullhd  is-11-tablet">
              <b-input :value="compteComptableOfTier" disabled>
              </b-input>
            </b-field>
            <b-field :label="$t('editionFacture.informations.customerReference')"
                     class="column is-4-fullhd is-5-tablet">
              <b-input v-model="factureDetail.referenceClient">
              </b-input>
            </b-field>
            <b-field :label="$t('editionFacture.informations.folderCode')"
                     class="column is-5-fullhd is-6-tablet">
              <b-input v-model="factureDetail.codeDossier">
              </b-input>
            </b-field>
          </div>
          <div class="column is-6 columns is-marginless is-multiline">
            <div class="column is-offset-3-fullhd is-9-fullhd is-offset-1-tablet is-11-tablet">
                <app-edition-intervenant :alignADroite="true"
                                         class="list-intervenants-item"
                                         :placeIntervenant="-1"
                                         :intervenant=destinataire
                                         :afficherRole="true"
                                         :afficherTitre="true"
                                         :afficherBox="true"
                                         :facture="factureDetail"
                                         :sens="constantes.SENS_VENTE"
                                         :intervenantsFacture=factureDetail.intervenants
                                         @addCommentaireFacturationOfIntervenant="addCommentaire"
                                         @payeur="payeur"
                                         @updateModeCalculHonoraire="updateModeCalculHonoraire"
                                         @destinataireComptable="destinataireComptable">
                </app-edition-intervenant>
            </div>
          </div>
        </div>
      </div>
      <div class="card-content">
        <liste-lignes-ventes
          :dcf="factureDetail"
          @typeProduitChange="findNewTypeProduit() "
          :isCreditNote="isCreditNote"
          :isAvoirLibre="isAvoirLibre"
          :error="false"
          :breadcrumb="breadcrumb"
          @calcul="calcul">
        </liste-lignes-ventes>
      </div>
      <app-modifier-reglement v-if="factureDetail.sens !== constantes.SENS_VENTE"
                              :facture="factureDetail"/>
      <app-conditions-reglement :devisCommande="factureDetail"
                                racineTraduction="editionFacture"/>
    </div>
    <br>
    <commentaires
      :type="factureDetail.type"
      :devisCommandeFacture="factureDetail">
    </commentaires>
    <br/>
    <div class="card">
      <header class="header-card">
        <p>
          {{ $t('piecesJointes.attachments')}}
        </p>
      </header>
      <div class="card-content">
        <app-pieces-jointes :checkPermissions="true"/>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import calculCommandeDevis from '@/services/devisCommandes/calcul/calculCommandeDevis';
import PiecesJointes from '@/components/general/piecesJointes';
import { SENS_VENTE, POURCENTAGE } from '@/configuration/devisConf';
import genererIntervenant from '@/services/devisCommandes/genererIntervenant';
import defineTitreIntervenant from '@/services/devisCommandes/defineTitreIntervenant';
import modificationLigne from '@/services/devisCommandes/modificationLigneCommande';
import messageErreur from '@/services/general/messageErreur';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import { COMMERCIAL, ASSISTANT_COMMERCIAL, DIRECTEUR_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import * as produitConf from '@/configuration/catalogue/produitConf';
import listeLignesVentes from '@/components/devisCommandes/editionDevisCommande/listeLignesVentes';
import { get as getTiers } from '@/api/tiers/index';
import { checkExercice } from '@/api/compta/exerciceComptable/index';
import categorieVenteInitialize from '@/services/devisCommandes/categorieVenteInitialize';
import regleFacturationInitialize from '@/services/devisCommandes/regleFacturationInitialize';
import updateModeCalculHonoraireLigneCommandeHonoraire from '@/services/ligneCommande/updateModeCalculHonoraire';
import selectionAgence from '@/components/general/selectionAgence';
import commentaires from '@/components/bodac/dcf/addEditDcf/commentaires/commentaires';
import debounce from 'lodash/debounce';
import validationEcriture from '@/services/ecritureComptable/validation';
import inputCurrency from '@/components/general/inputCurrency';
import userSelector from '@/components/commun/user/userSelector';
import selectionCampagne from '@/components/devisCommandes/selectionCampagne';
import { LISTE_APPLICATION_TVA } from '@/configuration/tiers/tiersConf';
import { DOCUMENT_VENTE } from '@/configuration/parametrage/tagConf';
import queryTagsTagInput from '@/components/general/tagInput/queryTagsTagInput';
import ModifierReglement from './modifierReglement';
import EditionIntervenant from './editionIntervenant';
import ConditionsReglement from '../devisCommandes/editionDevisCommande/conditionsReglement';

const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');
const Societe = createNamespacedHelpers('societe');
const CategorieVente = createNamespacedHelpers('categorieVente');

export default {
  props: {
    factureDetail: Object,
    breadcrumb: Array,
    isNewDevisCommande: Boolean,
    isCreditNote: Boolean,
    isAvoirLibre: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    listeLignesVentes,
    appConditionsReglement: ConditionsReglement,
    appEditionIntervenant: EditionIntervenant,
    appModifierReglement: ModifierReglement,
    appPiecesJointes: PiecesJointes,
    commentaires,
    selectionAgence,
    inputCurrency,
    userSelector,
    selectionCampagne,
    queryTagsTagInput,
  },
  data() {
    return {
      exerciceOk: true,
      errorsExercice: '',
      compteComptableOfTier: null,
      constantes: {
        CATEGORIE_DIVERS: produitConf.CATEGORIE_DIVERS,
        CATEGORIE_SALON: produitConf.CATEGORIE_SALON,
        CATEGORIE_SPONSORING: produitConf.CATEGORIE_SPONSORING,
        CATEGORIE_AUTRE: produitConf.CATEGORIE_AUTRE,
        SENS_VENTE,
        COMMERCIAL,
        DIRECTEUR_COMMERCIAL,
        ASSISTANT_COMMERCIAL,
        LISTE_APPLICATION_TVA,
        DOCUMENT_VENTE,
      },
    };
  },
  computed: {
    ...User.mapGetters({
      utilisateur: 'user',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
    }),
    ...CategorieVente.mapGetters({
      categorieProduit: 'categorieProduit',
    }),
    isDateCampagneDisabled() {
      const typesDateCampagneEnabled = [
        this.constantes.CATEGORIE_DIVERS,
        this.constantes.CATEGORIE_SALON,
        this.constantes.CATEGORIE_SPONSORING,
        this.constantes.CATEGORIE_AUTRE,
      ];
      return !typesDateCampagneEnabled.includes(this.factureDetail.categorieVente);
    },
    getReglesFacturation() {
      let societeId = this.societeActiveId;
      if (this.factureDetail.id) societeId = this.factureDetail.societeId;
      return this.parametre(typesParametres.PARAMETRES_KEYS.regleFacturation)
        .filter(regle => regle.societeId === societeId);
    },
    getApplicationTvaAnnonceur() {
      const annonceur = this.factureDetail.intervenants.find((int) => int.annonceur);
      return annonceur?.applicationTva || null;
    },
    destinataire() {
      return this.factureDetail.intervenants.find((inter) => {
        return inter.destinataire;
      });
    },
    isCommercial() {
      return ((this.isNewDevisCommande && this.utilisateur.profil === COMMERCIAL)
        || (!this.isNewDevisCommande && this.utilisateur.profil === COMMERCIAL
          && this.utilisateur.id === this.factureDetail.commercialId));
    },
    listeIntervenants() {
      if (this.factureDetail.intervenants.length <= 1) {
        return [];
      }
      return this.factureDetail.intervenants.filter((inter) => {
        return !inter.destinataire;
      });
    },
    isSyncRegleWithLignes() {
      if (this.factureDetail.regleFacturationId) {
        return this.factureDetail.lignesCommande.length > 0
          && this.factureDetail.lignesCommande.some(ligne => {
            return ligne.produit
              && (ligne.produit.regleFacturationId === this.factureDetail.regleFacturationId);
          });
      }
      return true;
    },
    modulePresseActive() {
      return this.parametresInterne(typesParametres.PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    moduleCampagneActive() {
      return this.parametresInterne(typesParametres.PARAMETRES_INTERNE_KEYS.campagne.key);
    },
    assistantEtCommercialObligatoireSurCommandeFacture() {
      return this.parametresInterne(typesParametres.PARAMETRES_INTERNE_KEYS
        .rendreObligatoireAssistantEtCommercialSurCommandeFacture.key);
    },
  },
  async mounted() {
    try {
      await this.loadParametreUtilisateur();
      await this.loadParametres([typesParametres.PARAMETRES_KEYS.regleFacturation]);
      await this.loadParametresInterne([typesParametres.PARAMETRES_INTERNE_KEYS.modulePresse.key,
        typesParametres.PARAMETRES_INTERNE_KEYS
          .rendreObligatoireAssistantEtCommercialSurCommandeFacture.key,
        typesParametres.PARAMETRES_INTERNE_KEYS.campagne.key]);
      await this.getCompteComptableOfDestinataireComptable();
      await checkExercice(this.factureDetail.societeId ? this.factureDetail.societeId
        : this.societeActiveId, this.factureDetail.dateDevisCommande)
        .then(response => {
          this.exerciceOk = response.data.result.state;
          if (response.data.result.errors !== null && response.data.result.errors.length >= 1) {
            const messages = [];
            validationEcriture(this.$i18n, response.data.result.errors, messages);
            this.errorsExercice = this.$i18n.t(messages[0].message, messages[0].parametres);
          }
        });
    } catch (e) {
      messageErreur(this.$i18n);
      throw (e);
    }
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    billDateChanged: debounce(async function billDateDealer() {
      await checkExercice(this.factureDetail.societeId ? this.factureDetail.societeId
        : this.societeActiveId, this.factureDetail.dateDevisCommande)
        .then(response => {
          this.exerciceOk = response.data.result.state;
          if (response.data.result.errors !== null && response.data.result.errors.length >= 1) {
            const messages = [];
            validationEcriture(this.$i18n, response.data.result.errors, messages);
            this.errorsExercice = this.$i18n.t(messages[0].message, messages[0].parametres);
          }
        });
    }),
    async updateModeCalculHonoraire() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await updateModeCalculHonoraireLigneCommandeHonoraire(
          this.factureDetail.lignesCommande,
          this.factureDetail.intervenants,
        );
        this.calcul();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    updateApplicationTvaAnnonceur(value) {
      const annonceur = this.factureDetail.intervenants.find((int) => {
        return int.annonceur;
      });
      if (annonceur) annonceur.applicationTva = value;
    },
    addCommentaire(commentaire) {
      if (!commentaire || commentaire === '') return;
      if (!this.factureDetail.commentaire) this.factureDetail.commentaire = '';
      this.factureDetail.commentaire = this.factureDetail.commentaire.concat(commentaire + '\n');
    },
    async getCompteComptableOfDestinataireComptable() {
      const destinataireComptable = this.factureDetail.intervenants.find((intervenant) => {
        return intervenant.destinataireComptable;
      });
      if (destinataireComptable === undefined || !destinataireComptable.tiersId) {
        this.compteComptableOfTier = null;
        return;
      }
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.compteComptableOfTier = (
          await getTiers(destinataireComptable.tiersId)
        ).data.result.compteComptable;
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    modificationLigneCommande(nouvelleLigneCommande, ordre) {
      modificationLigne(this.factureDetail, ordre, nouvelleLigneCommande[0]);
      this.calcul();
    },
    calcul() {
      calculCommandeDevis(this.factureDetail);
      if (this.modulePresseActive && !this.factureDetail.regleFacturationId) {
        regleFacturationInitialize(this.factureDetail);
      }
    },
    changeDestinataire(nouveauDestinataire) {
      const ancienDestinataire = this.destinataire;
      defineTitreIntervenant(nouveauDestinataire, this.$i18n);
      if (ancienDestinataire) {
        ancienDestinataire.destinataire = false;
        defineTitreIntervenant(ancienDestinataire, this.$i18n);
      }
      nouveauDestinataire.destinataire = true;
    },
    async destinataireComptable(intervenant) {
      this.factureDetail.intervenants
        .filter((inter) => {
          return inter.tiersId !== intervenant.tiersId;
        })
        .forEach((inter) => {
          inter.destinataireComptable = false;
        });
      await this.getCompteComptableOfDestinataireComptable();
    },
    payeur(intervenant) {
      intervenant.repartition = 100;
      intervenant.typeRepartition = POURCENTAGE;
      this.factureDetail.intervenants
        .filter((inter) => {
          return inter.tiersId !== intervenant.tiersId;
        })
        .forEach((inter) => {
          inter.payeur = false;
          defineTitreIntervenant(inter, this.$i18n);
        });
    },
    ajouterIntervenant() {
      const intervenant = genererIntervenant();
      if (this.factureDetail.intervenants.length === 0) {
        intervenant.destinataire = true;
      }
      defineTitreIntervenant(intervenant, this.$i18n);
      this.factureDetail.intervenants.push(intervenant);
    },
    supprimerIntervenant(intervenant) {
      const intervenantIndex = this.factureDetail.intervenants.indexOf(intervenant);
      this.factureDetail.intervenants.splice(intervenantIndex, 1);
    },
    findNewTypeProduit() {
      categorieVenteInitialize(this.factureDetail);
      if (this.modulePresseActive && !this.factureDetail.regleFacturationId) {
        regleFacturationInitialize(this.factureDetail);
      }
    },
  },
};
</script>
